import React from 'react'
import { priceFormat } from '@framework/utils/parse-util'
import ProductRelatedTabs from '../ProductRelatedTabs'
import {
  ICustomAttribute,
  IProduct,
} from '@components/utils/model/product.model'
import { GroupedData } from '@framework/utils/lodash'

interface IProps {
  isOnlyMobile: boolean
  product: IProduct
  selectedSizeProductDiscount: number
  attrGroup: GroupedData<ICustomAttribute>
  selectedSizeProduct: any
}

const ProductRateComponent = ({
  isOnlyMobile,
  product,
  selectedSizeProduct,
  selectedSizeProductDiscount,
  attrGroup,
}: IProps) => {
  return (
    <div className="flex flex-col w-full mobile-tab" id="productColors">
      <div
        className={`flex justify-between order-2 flex-col px-4 mt-0 sm:px-0`}
      >
        <div className="item-left">
          {/* <h2 className="sr-only">{PRODUCT_INFORMATION}</h2> */}
          <p className="h-5 text-sm font-semibold text-primary sm:text-md">
            {`${
              selectedSizeProduct?.listPrice?.raw?.withTax >
              selectedSizeProduct?.price?.raw?.withTax
                ? ''
                : 'MRP'
            } ${priceFormat(selectedSizeProduct?.price?.raw?.withTax)}`}
            {selectedSizeProduct?.listPrice?.raw?.withTax >
            selectedSizeProduct?.price?.raw?.withTax ? (
              <>
                <span className="px-2 text-sm font-normal text-brown-light sm:text-md">
                  MRP{' '}
                  <span className="line-through">
                    {priceFormat(selectedSizeProduct?.listPrice?.raw?.withTax)}
                  </span>
                </span>
                {selectedSizeProductDiscount > 0 && (
                  <span className="text-sm font-normal text-green sm:text-md">
                    {selectedSizeProductDiscount}% off
                  </span>
                )}
              </>
            ) : null}
          </p>
          <p className="text-sm pt-1 font-normal text-brown-light sm:text-md">
            Inclusive of all taxes
          </p>
        </div>
        <div className="desktop-laptop">
          {attrGroup['product.relatedcategories']?.length && (
            <div className="flex-1 w-full pl-4 mt-2 mb-1 sm:pl-0">
              <ProductRelatedTabs
                product={product}
                grpData={attrGroup}
                pageType="PDP"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductRateComponent
